import React, { useEffect, useState } from "react";
import styled from "styled-components";
import background from "../../assets/images/mix.jpg";

const Hero = () => {
  const [isCaptionVisible, setIsCaptionVisible] = useState(false);

  useEffect(() => {
    // Set a delay to initiate the transition after a certain period
    const delay = setTimeout(() => {
      setIsCaptionVisible(true);
    }, 500); // Adjust the delay time as needed

    return () => clearTimeout(delay);
  }, []);

  return (
    <MainWrap id="home">
      <Overlay />
      <TextWrap visible={isCaptionVisible}>
        <Caption>
          You have landed in the right place, let us spin your next event
          whatever it might be
        </Caption>
        <Button>Book Now</Button>
      </TextWrap>
    </MainWrap>
  );
};

export default Hero;

const MainWrap = styled.div`
  position: relative;
  width: 100%;
  height: 700px;
  background-image: url(${background});
  background-size: cover;
  background-position: center;

  @media (max-width: 767px) {
    height: 400px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const TextWrap = styled.div`
  width: 60%;
  text-transform: uppercase;
  position: absolute;
  bottom: 40px;
  right: ${({ visible }) => (visible ? "40px" : "-100%")};
  text-align: right;
  padding: 10px;
  border-right: solid 3px rgb(192, 192, 192);
  transition: right 1s ease;
  font-family: "Exo", sans-serif;

  @media (max-width: 767px) {
    width: 80%;
  }
`;

const Caption = styled.h1`
  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

const Button = styled.button`
  padding: 10px;
  font-weight: bold;
  font-size: 18px;
  border: solid rgb(192, 192, 192) 2px;
  background: black;
  color: rgb(192, 192, 192);
  cursor: pointer;
  transition: background 0.3s ease-out;

  &:hover {
    background: #000742;
  }

  @media (max-width: 767px) {
    font-size: 14px;
    padding: 5px;
  }
`;
